/* eslint-disable */
import { StyleSheet } from 'react-native'
import {Fonts} from '../../Themes'
export default StyleSheet.create({
  container: {
    flex: 1,
   
  },
  spacer : {
    flex: 1,
    height: 1,
    width: '100%',
    backgroundColor: Fonts.style.color.disable
  }
})
